// Import necessary dependencies
import updateExternalDomainLinks from "src/decidim/external_domain_warning";
import ExternalLink from "src/decidim/external_link";

// Ensure the original initializer is called
const originalInitializer = window.initializer || (() => {});

// Redefine the initializer function
const customInitializer = (element = document) => {
  // Select all anchor tags that do not have specific data attributes
  element.querySelectorAll("a:not([data-external-link=\"false\"]):not([aria-label=\"Dropdown\"])").forEach((elem) => {

    if ((new URL(elem.href)).hostname === window.location.hostname) {
      return;
    }

    // both functions (updateExternalDomainLinks and ExternalLink) are related, so if we disable one, the other also
    updateExternalDomainLinks(elem);

    // Create a new ExternalLink instance
    return new ExternalLink(elem);
  });

  // Call the original initializer function for other initializations
  originalInitializer(element);
};

// Override the global initializer with the custom one
window.initializer = customInitializer;

// Run the custom initializer on DOMContentLoaded
document.addEventListener("DOMContentLoaded", () => customInitializer());